import { LevelShow } from './LevelShow';
import { LevelEdit } from './LevelEdit';
import { LevelCreate } from './LevelCreate';
import { LevelList } from './LevelList';

export default {
    list: LevelList,
    show: LevelShow,
    edit: LevelEdit,
    create: LevelCreate,
};
